/* eslint-disable react/prop-types,react/jsx-props-no-spreading */
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import { Row, Col, Button, Div } from '@pinpoint/design-kit';

import FactorChart from './factor';
import FacetChart from './facet';
import Top7Chart from './top7';

export default class OceanChart extends Component {
	constructor(props) {
		super(props);
		this.state = {
			chart: props.chart,
		};
	}

	componentDidUpdate() {
		ReactTooltip.rebuild();
	}

	render() {
		const { chart } = this.state;
		return (
			<>
				<Button
					zIndex="10"
					pos="absolute"
					top="1.5rem"
					right="1.5rem"
					bg="brand500"
					hoverBg="brand600"
					data-tip={chart === 'TOP7' ? 'Return to factors and facets dashboard' : 'View top 7 most divergent facets'}
					onClick={() => {
						if (chart === 'TOP7') {
							this.setState({ chart: 'OCEAN' });
						} else {
							this.setState({ chart: 'TOP7' });
						}
					}}
				>
					{chart === 'TOP7' ? 'FACTORS AND FACETS' : 'TOP 7 TRAITS'}
				</Button>
				{chart === 'OCEAN' ? (
					<Div h="100%" minH="100%" w="100%" minW="100%">
						<Row h="100%">
							<Col size={{ xs: '12', lg: '6' }} gutterWidth="1.25rem">
								<Div
									minH="400px"
									h="100%"
									w="100%"
									bg="white"
									p={{ x: '1.5rem', y: '1.25rem' }}
									rounded="md"
									data-test="factor-rose-div"
								>
									<FactorChart {...this.props} />
								</Div>
							</Col>
							<Col size={{ xs: '12', lg: '6' }} gutterWidth="1.25rem">
								<Div
									minH="400px"
									h="100%"
									w="100%"
									bg="white"
									p={{ x: '1.5rem', y: '1.25rem' }}
									rounded="md"
									data-test="facet-rose-div"
								>
									<FacetChart {...this.props} />
								</Div>
							</Col>
						</Row>
					</Div>
				) : (
					<Div h="100%" minH="100%" w="100%" minW="100%">
						<Row h="100%">
							<Col size={{ xs: '12' }} gutterWidth="1.25rem">
								<Div minH="400px" h="100%" w="100%" rounded="md" bg="white" p={{ x: '1.5rem', y: '1.25rem' }}>
									<Top7Chart {...this.props} />
								</Div>
							</Col>
						</Row>
					</Div>
				)}
			</>
		);
	}
}
